import {
  AudioMessageContent,
  ConversationMessageDto,
  ImageMessageContent,
  MessageContent as MessageContentType,
} from '@endion/types';
import { MemoizedReactMarkdown } from '../markdown';
import { MarkdownLink, MyListItem, PropertyList } from '../markdown-components/markdown-components';
import { MessageBubble } from './message-bubble';

export function MessageContent({
  role,
  content,
}: {
  role: ConversationMessageDto['role'];
  content: MessageContentType[];
}) {
  return content.map((contentItem) => {
    switch (contentItem.type) {
      case 'text':
        return <TextMessage key={contentItem.text} role={role} text={contentItem.text} />;
      case 'image':
        return (
          <ImageMessage
            key={contentItem.resource.kind === 'url' ? contentItem.resource.url : contentItem.resource.fileId}
            role={role}
            imageContent={contentItem}
          />
        );
      case 'audio':
        return (
          <AudioMessage
            key={contentItem.resource.kind === 'url' ? contentItem.resource.url : contentItem.resource.fileId}
            role={role}
            audioContent={contentItem}
          />
        );
    }
  });
}

function TextMessage({ role, text }: { role: ConversationMessageDto['role']; text: string | undefined }) {
  // if only a tool invocation is present, we don't want to render the text
  if (!text) return null;
  return (
    <MessageBubble role={role}>
      <MemoizedReactMarkdown
        components={{
          ol: PropertyList,
          a: MarkdownLink,
          li: MyListItem,
        }}
      >
        {text}
      </MemoizedReactMarkdown>
    </MessageBubble>
  );
}

function AudioMessage({ role }: { audioContent: AudioMessageContent; role: ConversationMessageDto['role'] }) {
  return <MessageBubble role={role}>Este es un mensaje de audio.</MessageBubble>;
}

function ImageMessage({ role }: { imageContent: ImageMessageContent; role: ConversationMessageDto['role'] }) {
  return <MessageBubble role={role}>Esta es una imagen.</MessageBubble>;
}
